import { useGetClinicStatusForPatient as useGeneratedGetClinicStatusForPatient } from "@/api/generated";

export const useGetClinicStatusForPatient = ({
  enabled = true,
  suppressErrorToast = false,
}: {
  enabled?: boolean;
  suppressErrorToast?: boolean;
} = {}) =>
  useGeneratedGetClinicStatusForPatient({
    query: {
      enabled,
      meta: suppressErrorToast ? { suppressErrorToast: true } : undefined,
      select: (status) => ({
        ...status,
        hasOngoingClinicVisit:
          status.latest_visit?.status === "pending" ||
          status.latest_visit?.status === "in-progress",
      }),
    },
  });
